import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "src/app/constants/endpointsURL";
import { Generic } from "../models/generic.model";

@Injectable({
  providedIn: "root",
})
export class GenericoService {
  env = environment.env;
  genericoURL = endpointsURL.genericoURL;

  constructor(private httpClient: HttpClient) {}

  public getGenericoByActiveUser(): Observable<Generic> {
    return this.httpClient.get<Generic>(
      `${this.env}${this.genericoURL}/getOneByActiveConcessionaire`
    );
  }
}
